import React, { useMemo } from 'react';
import '../DesktopLogin/DesktopLogin.css';
import DesktopThreadsBackground from '../DesktopLogin/DesktopThreadsBackground';
import loopinoLogo from '../../../assets/images/LOOPINO-logo-new.svg';
import useLanguage from '../../../hooks/useLanguage';
import useVerifyEmailFlow from '../../../hooks/useVerifyEmailFlow';
import { registerDesktopTranslations } from '../i18n/registerDesktopTranslations';

registerDesktopTranslations();

const DesktopVerifyEmail = () => {
  const { t } = useLanguage();
  const heroThreadsColor = useMemo(() => [0.98, 0.92, 1], []);
  const { status, countdown, redirectToLogin } = useVerifyEmailFlow({ redirectDelayMs: 5000 });

  const isSuccess = status === 'success';
  const isError = status === 'error' || status === 'missing';
  const isVerifying = status === 'verifying' || status === 'idle';

  const statusMessage = (() => {
    if (status === 'success') {
      return t('login.verifyEmail.status.success');
    }
    if (status === 'error') {
      return t('login.verifyEmail.status.error');
    }
    if (status === 'missing') {
      return t('login.verifyEmail.status.missing');
    }
    return t('login.verifyEmail.status.verifying');
  })();

  return (
    <div className="desktop-login-container">
      <div className="desktop-login-grid">
        <section className="desktop-login-hero" aria-live="polite">
          <div className="desktop-hero-glow" aria-hidden="true" />
          <div className="desktop-login-hero-card">
            <DesktopThreadsBackground
              color={heroThreadsColor}
              amplitude={1}
              distance={0.3}
              enableMouseInteraction
              aria-hidden="true"
            />
            <div className="desktop-hero-content">
              <div className="desktop-hero-branding">
                <img src={loopinoLogo} alt={t('desktop.brand.logoAlt', { defaultValue: 'Loopino' })} />
              </div>
              <h2>{t('login.desktop.tagline', { defaultValue: 'Il tuo social media manager AI powered' })}</h2>
              <p>{t('login.desktop.hero.description')}</p>
              <div className="desktop-hero-chips">
                <span>{t('login.desktop.hero.chips.trends')}</span>
                <span>{t('login.desktop.hero.chips.calendar')}</span>
                <span>{t('login.desktop.hero.chips.ai')}</span>
              </div>
              <div className="desktop-hero-stats">
                <div>
                  <strong>{t('login.desktop.hero.stats.flowTitle')}</strong>
                  <span>{t('login.desktop.hero.stats.flowSubtitle')}</span>
                </div>
                <div>
                  <strong>{t('login.desktop.hero.stats.creativityTitle')}</strong>
                  <span>{t('login.desktop.hero.stats.creativitySubtitle')}</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="desktop-login-card" aria-live="polite">
          <header className="desktop-login-card-header">
            <div>
              <p className="desktop-login-eyebrow">{t('login.verifyEmail.eyebrow')}</p>
              <h1>{t('login.verifyEmail.title')}</h1>
              <p className="desktop-login-description">{t('login.verifyEmail.description')}</p>
            </div>
          </header>

          <div className="desktop-login-form">
            <div
              className={`desktop-general-message ${
                isSuccess ? 'desktop-general-message-success' : isError ? 'desktop-general-message-error' : ''
              }`}
            >
              <div className="desktop-general-message-content">
                <span>{statusMessage}</span>
                {countdown !== null && (
                  <span className="desktop-general-subtext">
                    {t('login.verifyEmail.redirecting', { count: countdown })}
                  </span>
                )}
              </div>
              {isVerifying && <div className="desktop-loading-spinner" aria-hidden="true" />}
            </div>

            <div className="desktop-submit-section">
              <button type="button" className="desktop-submit-button" onClick={redirectToLogin}>
                {t('login.verifyEmail.cta')}
              </button>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default DesktopVerifyEmail;
